import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from "react";
import {useAuth} from "../contexts/AuthContext";

export default function AccountMenu() {

    const auth = useAuth()

    const dropdownRef = useRef<HTMLDivElement>(null);
    const [showAccountDropdown, setShowAccountDropdown] = useState(false);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (dropdownRef.current) {
                if (dropdownRef.current.contains(event.target as Element)) return
                setShowAccountDropdown(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const closeDropdown = () => {
        setShowAccountDropdown(false)
    }

    return <div className="relative inline-block text-white-t">
        <div>
            <button type="button" onClick={() => setShowAccountDropdown(!showAccountDropdown)}
                    className="flex items-center text-md bg-neutral-700 hover:brightness-90 rounded-full">
                <span className="sr-only">Open user menu</span>
                <img className="w-10 h-10 rounded-full" src={auth.avatarUrl} alt="avatar"/>
                <span className="m-2 me-4">{auth.userName ?? "-1"}</span>
            </button>
        </div>
        {showAccountDropdown && <div ref={dropdownRef} className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-neutral-600 text-white text-sm overflow-hidden">
            <div>
                <Link to="/client" onClick={closeDropdown} className="block px-4 py-2 hover:bg-neutral-700">Client</Link>
                <Link to="/account" onClick={closeDropdown} className="block px-4 py-2 hover:bg-neutral-700">Account</Link>
                <Link to="/login?do=logout" onClick={closeDropdown} className="block px-4 py-2 hover:bg-neutral-700">Sign out</Link>
            </div>
        </div>}
    </div>
}